<footer
    *ngIf="!router.url.includes('panel')"
    class="footer-top-area pt-100 pb-70"
>
    <div class="container">
        <div class="row">
            <div class="col-lg-3 col-md-6">
                <div class="single-footer-widget">
                    <a
                        style="
                            color: aliceblue;
                            font-weight: bold;
                            font-size: 2em;
                        "
                        class="logo"
                        routerLink="/"
                    >
                        <!-- <img src="assets/img/white-logo.png" alt="Logo"> -->
                        enCloud
                    </a>

                    <p>
                        Poveedor en servicios en la nube y tecnología de redes,
                        reconocidos por nuestro compromiso con la calidad,
                        innovación y apoyo a sectores clave como la
                        investigación y el desarrollo de nuevas tecnologias.
                    </p>
                    <ul class="social-icon">
                        <li>
                            <a href="https://facebook.com/encloudmx/" target="_blank"
                                ><i class="fa-brands fa-square-facebook"></i
                            ></a>
                        </li>
                        <li>
                            <a href="https://x.com/encloudmx" target="_blank"
                                ><i class="fa-brands fa-square-x-twitter"></i
                            ></a>
                        </li>
                        <li>
                            <a href="https://instagram.com/encloudmx/" target="_blank"
                                ><i class="fa-brands fa-square-instagram"></i
                            ></a>
                        </li>
                        <li>
                            <a href="https://linkedin.com/company/encloudmx/" target="_blank"
                                ><i class="fa-brands fa-linkedin"></i
                            ></a>
                        </li>
                    </ul>
                </div>
            </div>

            <div class="col-lg-3 col-md-6">
                <div class="single-footer-widget pl-5">
                    <!-- <h3>Hosting</h3>

                    <ul>
                        <li><a routerLink="/">Shared Hosting</a></li>
                        <li><a routerLink="/">WordPress Hosting</a></li>
                        <li><a routerLink="/">Reseller Hosting</a></li>
                        <li><a routerLink="/">VPS Hosting</a></li>
                        <li><a routerLink="/">Dedicated Server</a></li>
                    </ul> -->
                </div>
            </div>

            <div class="col-lg-3 col-md-6">
                <div class="single-footer-widget">
                    <h3>Servicios</h3>

                    <ul>
                        <li>
                            <a routerLink="/services/cloud-computing"
                                >Cómputo en la Nube</a
                            >
                        </li>
                        <li>
                            <a routerLink="/services/cloud-storage"
                                >Almacenamiento en la Nube</a
                            >
                        </li>
                        <li>
                            <a routerLink="/services/dedicated-hosting"
                                >Alojamiento Especializado</a
                            >
                        </li>
                        <li>
                            <a routerLink="/services/dedicated-database"
                                >Alojamiento Base de Datos</a
                            >
                        </li>
                        <li>
                            <a routerLink="/services/gaming-servers"
                                >Servidores para videojuegos</a
                            >
                        </li>
                        <li>
                            <a
                                routerLink="/services/intermediate-data-protection"
                                >Resguardo de Datos</a
                            >
                        </li>
                        <li>
                            <a routerLink="/services/equipment-administration"
                                >Administración de Equipos</a
                            >
                        </li>
                    </ul>
                </div>
            </div>

            <div class="col-lg-3 col-md-6">
                <div class="single-footer-widget">
                    <h3>Soporte</h3>

                    <ul>
                        <li><a routerLink="/contact">Contacto</a></li>
                        <li><a routerLink="/faq">Preguntas Frecuentes</a></li>
                        <li><a routerLink="/about-us">Sobre Nosotros</a></li>
                        <li><a routerLink="/news">Noticias</a></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</footer>

<footer *ngIf="!router.url.includes('panel')" class="footer-bottom-area">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-4 col-md-6"></div>

            <div class="col-lg-4 col-md-6">
                <ul>
                    <li>
                        <a routerLink="/terms-conditions"
                            >Términos y Condiciones</a
                        >
                    </li>
                    <li>
                        <a routerLink="/privacy-policy"
                            >Política de Privacidad</a
                        >
                    </li>
                </ul>
            </div>

            <div class="col-lg-4 col-md-12">
                <div class="designed"></div>
            </div>
        </div>
    </div>
</footer>

<div *ngIf="!router.url.includes('panel')" class="go-top">
    <i class="bx bx-chevrons-up bx-fade-up"></i>
    <i class="bx bx-chevrons-up bx-fade-up"></i>
</div>
